module.exports = __webpack_public_path__ + "37478ebe5165ce7a0ec6254e4e37da7b.pdf";